import { ViewType } from 'containers/dispatch/constants';
import { JobListCardItem } from 'containers/dispatch/dispatch.model';
import { JobStatus } from 'containers/jobs/constant';

export const STATUS_PIN_FALLBACK_COLORS: Partial<Record<JobStatus, string>> = {
  [JobStatus.INBOX]: '#3E556D',
  [JobStatus.SUBMITTED]: '#00ABB8',
  [JobStatus.CONFIRMED]: '#4A8DF2',
  [JobStatus.IN_PROGRESS]: '#F88A29',
  [JobStatus.DONE]: '#27AE60',
  [JobStatus.PENDING]: '#DBAC00',
  [JobStatus.DONE_PENDING_APPROVAL]: '#BD68DC',
  [JobStatus.CANCELED]: '#D95945',
  [JobStatus.ARCHIVED]: '#828282',
  [JobStatus.REJECTED]: '#D95945'
};

const DEFAULT_MEMBER_PIN_COLOR = '#3876BB';
const DEFAULT_STATUS_PIN_COLOR = '#00ABB8';

export const getStatusPinColor = (job: JobListCardItem): string => {
  return job.statusColorCode || STATUS_PIN_FALLBACK_COLORS[job.status as JobStatus] || DEFAULT_STATUS_PIN_COLOR;
};

export const getMarkerPinColor = (job: JobListCardItem, mapView: ViewType): string => {
  if (mapView === ViewType.MEMBER) {
    return job.assigneeColorCode || DEFAULT_MEMBER_PIN_COLOR;
  }

  return getStatusPinColor(job);
};
